// @ts-nocheck
import { useState } from 'react';
import { Link } from 'react-router-dom';
import { Stack, Group, Center } from '@/components/ui/layout';
import { Title, Text, Button, Anchor } from '@/components/ui/core';
import { TextInput, PasswordInput, Checkbox } from '@/components/ui/inputs';
import { IconUser, IconMail, IconLock, IconArrowLeft } from '@tabler/icons-react';
import { AuthLayoutWrapper, SocialLoginButtons, PasswordStrength } from '../components';

export default function RegisterGradient() {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [acceptTerms, setAcceptTerms] = useState(false);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    console.log('Register attempt:', { name, email, password });
  };

  return (
    <AuthLayoutWrapper
      variant="gradient"
      glassEffect
      gradientFrom="#ec4899"
      gradientTo="#8b5cf6"
    >
      <Stack gap="lg">
        {/* Back button */}
        <Button
          component={Link}
          to="/app/demo/auth-pages/register"
          variant="subtle"
          size="xs"
          leftSection={<IconArrowLeft size={14} />}
          w="fit-content"
        >
          Back to variants
        </Button>

        {/* Header */}
        <Center>
          <Stack align="center" gap="xs">
            <Center
              style={{
                width: 56,
                height: 56,
                borderRadius: 16,
                background: 'linear-gradient(135deg, #ec4899, #8b5cf6)',
                boxShadow: '0 4px 14px rgba(236, 72, 153, 0.4)',
              }}
            >
              <Text size="xl" fw={700} c="white">R</Text>
            </Center>
            <Title order={2} ta="center">Join us today</Title>
            <Text c="dimmed" size="sm" ta="center">
              Create your account in seconds
            </Text>
          </Stack>
        </Center>

        {/* Social Login First */}
        <SocialLoginButtons
          providers={['google', 'apple']}
          layout="vertical"
          showDivider={false}
        />

        <Group gap="xs" justify="center">
          <div style={{ flex: 1, height: 1, backgroundColor: 'var(--mantine-color-gray-3)' }} />
          <Text size="xs" c="dimmed">or with email</Text>
          <div style={{ flex: 1, height: 1, backgroundColor: 'var(--mantine-color-gray-3)' }} />
        </Group>

        {/* Form */}
        <form onSubmit={handleSubmit}>
          <Stack gap="md">
            <TextInput
              label="Full name"
              placeholder="Your name"
              leftSection={<IconUser size={16} />}
              value={name}
              onChange={(e) => setName(e.target.value)}
              required
            />

            <TextInput
              label="Email"
              placeholder="your@email.com"
              leftSection={<IconMail size={16} />}
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />

            <div>
              <PasswordInput
                label="Password"
                placeholder="Create a password"
                leftSection={<IconLock size={16} />}
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
              />
              {password && (
                <PasswordStrength password={password} variant="requirements" showLabel />
              )}
            </div>

            <Checkbox
              label={
                <Text size="sm">
                  I accept the <Anchor size="sm">Terms of Service</Anchor>
                </Text>
              }
              checked={acceptTerms}
              onChange={(e) => setAcceptTerms(e.currentTarget.checked)}
            />

            <Button
              type="submit"
              fullWidth
              variant="gradient"
              gradient={{ from: '#ec4899', to: '#8b5cf6' }}
            >
              Create account
            </Button>
          </Stack>
        </form>

        {/* Login Link */}
        <Text ta="center" size="sm">
          Already a member?{' '}
          <Anchor component={Link} to="/app/demo/auth-pages/login/gradient" fw={500}>
            Sign in
          </Anchor>
        </Text>
      </Stack>
    </AuthLayoutWrapper>
  );
}
